import { PaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';
import ComplaintMessage from '../../models/ComplaintMessage';


export interface ComplaintMessageDetailState extends PaginatedApiState {
  message?: ComplaintMessage
}

export default requestReducer<ComplaintMessageDetailState>('COMPLAINT_MESSAGE_DETAIL')
